// LiveStreamKaraokeTooltip.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import LiveStreamKaraokeItem from '../container/LiveStreamKaraokeItem.js';

import FadeIn from '../style/FadeIn.js';
import FadeOut from '../style/FadeOut.js';

import trackMixpanel, {
  EventTypes,
  getViewId,
  ModalId,
  ButtonId,
} from '../resource/mixpanel.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

const TOOLTIP_DISPLAY_MSEC = 8000; // TODO: remote config

export class LiveStreamKaraokeTooltip extends React.PureComponent {
  timeout = null;
  componentDidMount() {
    const { close } = this.props;
    this.timeout = setTimeout(() => {
      close();
    }, TOOLTIP_DISPLAY_MSEC);
  }
  componentDidUpdate(prevProps) {
    const { streamId, close } = this.props;
    if (streamId !== prevProps.streamId) {
      close();
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  trackUserClick = () => {
    trackMixpanel({
      type: EventTypes.USER_CLICKED,
      payload: {
        viewId: getViewId({
          pathname: window.location.pathname,
        }),
        buttonId: ButtonId.LiveStream.CommandHint,
        modalId: ModalId.LiveStream.CommandHint,
      },
    });
  };
  handleOnClick = () => {
    const { openLiveStreamKaraokeModal } = this.props;
    this.trackUserClick();
    openLiveStreamKaraokeModal();
  };
  render() {
    const { t, status, streamId, karaokeIds } = this.props;
    if (karaokeIds === null) return null;
    return (
      <StyledLiveStreamKaraokeTooltip status={status}>
        <TooltipContainer onClick={this.handleOnClick}>
          <TooltipTitle>
            {t('command_list_description', {
              ns: TranslationNamespace.GIFT,
            })}
          </TooltipTitle>
          {karaokeIds?.slice(0, 3).map(karaokeId => (
            <LiveStreamKaraokeItem
              key={karaokeId}
              karaokeId={karaokeId}
              streamId={streamId}
              shouldUseMarquee={false}
              clickable={false}
              titleSize={12}
            />
          ))}
        </TooltipContainer>
      </StyledLiveStreamKaraokeTooltip>
    );
  }
}

LiveStreamKaraokeTooltip.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string,
  streamId: PropTypes.string,
  karaokeIds: PropTypes.array,
  close: PropTypes.func,
  openLiveStreamKaraokeModal: PropTypes.func,
};

LiveStreamKaraokeTooltip.defaultProps = {
  status: 'display',
  streamId: '',
  karaokeIds: null,
  close: () => null,
  openLiveStreamKaraokeModal: () => null,
};

const StyledLiveStreamKaraokeTooltip = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  width: 156px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
  background-color: rgba(25, 25, 25, 0.9);
  border-radius: 8px;
  animation: 0.6s forwards
    ${({ status }) => ('closing' === status ? FadeOut : FadeIn)};
  cursor: pointer;
  ::before {
    content: '';
    position: absolute;
    top: -24px;
    right: 28px;
    border-bottom: 12px solid rgba(25, 25, 25, 0.9);
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    transform: translate(-50%, 100%);
    opacity: 0.9;
  }
`;

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  > button {
    margin-bottom: 4px;
  }
`;

const TooltipTitle = styled.div`
  line-height: 1.5;
  font-size: 12px;
  color: #c8c8c8;
  margin-bottom: 8px;
  text-align: center;
`;

export default withTranslation()(LiveStreamKaraokeTooltip);
